import { services } from '../../core/feathers'
import { normalize } from 'normalizr'
import { schemas } from '..'
import { batch } from '../../modules/lib/batchReducer'
import { mergeEntities } from '../../modules/entities'

export default function configureAuctionListeners(dispatch, getState) {
  services.auctions.on('patched', auction => {
    // TODO: only handle updates on auctions the user is
    // active on, or has saved, otherwise every auction patch
    // will be sent to every user
    const { entities } = normalize(auction, schemas.auctions)
    dispatch(batch('AUCTION_PATCHED_EVENT', mergeEntities(entities)))
  })
}



// WEBPACK FOOTER //
// ./src/services/auction/listeners.js